export default "__VITE_ASSET__3L8V5llw__"